package fr.frux.feature.site.detail

/**
 * Origine d'un lieu importé en masse, reconnue par le pseudo réservé de son compte système, comme
 * `ImportedTreeSource` sur la fiche arbre : le contrat public n'expose pas `external_source`, le
 * pseudo suffit sans élargir l'API. Jardins OSM (ADR 0037, V10) et vergers partagés de la Ville
 * d'Angers (ADR 0010 amendé le 2026-10-30, V82, #690), vergers de Cergy et jardins partagés de
 * La Rochelle (V86, #713). Le tap ouvre la page du jeu, qui porte l'attribution due.
 */
enum class ImportedSiteSource(
    val username: String,
    val url: String,
) {
    OSM(username = "openstreetmap", url = "https://www.openstreetmap.org/copyright"),
    ANGERS(username = "ville-d-angers", url = "https://data.angers.fr/explore/dataset/vergers-angers/"),
    CERGY(username = "ville-de-cergy", url = "https://www.data.gouv.fr/datasets/vergers-de-cergy"),
    LA_ROCHELLE(
        username = "agglomeration-de-la-rochelle",
        url = "https://www.data.gouv.fr/datasets/espaces-verts-jardins-et-vergers-partages",
    ),
    ;

    companion object {
        fun fromUsername(username: String?): ImportedSiteSource? = entries.firstOrNull { it.username == username }
    }
}
